import type { ThemeVariant } from '../../contract.js';
import { defaultLight, defaultDark } from '../default/variants.js';

/**
 * Neon family — promoted from `skin_neon` overlay to a family
 * (Driver Themes ticket). Both variants inherit Default's chrome
 * tokens (fonts, motion, radii, surfaces, chrome glass recipes)
 * and override only the accent + charging colours that give the
 * family its visual identity. The shader-rendered ChargingAnimation
 * is where the synthwave look lives; the surrounding UI chrome
 * stays Default-shaped so existing components feel familiar.
 *
 * Spec accent / charging values are pulled verbatim from the
 * ticket's per-family table. Charging is the EVI brand green
 * across all four promoted families because the "energy in motion"
 * token should stay consistent with the platform's core brand
 * regardless of theme; only accent picks up the per-family hue.
 */
export const neonLight: ThemeVariant = {
  mode: 'light',
  tokens: {
    ...defaultLight.tokens,
    colors: {
      ...defaultLight.tokens.colors,
      accent: '#FF2EC8',
      accentSoft: 'rgba(255, 46, 200, 0.18)',
      charging: '#21c163',
      chargingGlow: 'rgba(33, 193, 99, 0.45)',
    },
  },
};

export const neonDark: ThemeVariant = {
  mode: 'dark',
  tokens: {
    ...defaultDark.tokens,
    colors: {
      ...defaultDark.tokens.colors,
      accent: '#FF2EC8',
      accentSoft: 'rgba(255, 46, 200, 0.18)',
      charging: '#21c163',
      chargingGlow: 'rgba(33, 193, 99, 0.55)',
    },
  },
};
